(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["syleksa-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const header = document.querySelector('.syleksa-header');
    const drawer = document.getElementById('syleksa-mobile-menu');
    const toggle = document.querySelector('[data-syleksa-menu-toggle]');
    if (!header) return;
    if (header.classList.contains('syleksa-header--transparent')) {
      const onScroll = () => { if (window.scrollY > 24) header.classList.add('is-scrolled'); else header.classList.remove('is-scrolled'); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    if (toggle && drawer) {
      if (!drawer.classList.contains('is-open')) drawer.setAttribute('inert', '');
      const focusables = () => drawer.querySelectorAll('a[href], button');
      function openDrawer() {
        drawer.classList.add('is-open');
        drawer.removeAttribute('inert');
        drawer.setAttribute('aria-hidden', 'false');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Close menu');
        const f = focusables();
        if (f.length) f[0].focus();
      }
      function closeDrawer(returnFocus) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('inert', '');
        drawer.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
        if (returnFocus !== false) toggle.focus();
      }
      toggle.addEventListener('click', () => {
        if (drawer.classList.contains('is-open')) closeDrawer(); else openDrawer();
      });
      drawer.addEventListener('click', (e) => { if (e.target.tagName === 'A') closeDrawer(false); });
      document.addEventListener('keydown', (e) => {
        if (!drawer.classList.contains('is-open')) return;
        if (e.key === 'Escape') { closeDrawer(); return; }
        if (e.key === 'Tab') {
          const f = focusables(); if (!f.length) return;
          const first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
